export const ENDPOINTS = {
  SETUP: {
    kibor_LIST: '/kibor/history',
    kibor_SAVE: '/kibor',
    get_kibor_current: '/kibor',
    GET_ALL_DOCUMENTS: '/get-all-docs',
    SAVE_DOCUMENT: '/save-docs',
    pickList: '/pick-list/refCdValsForGrps',
    ref_grps: '/ref-grps',
    ref_grp_SAVE: '/save-ref-cd-grp',
    ref_vals: '/pick-list/refCdValsForGrp',
    ref_val_SAVE: '/save-ref-cd-val',
    grntr_SAVE: '/grntr/save-grntr',
    grntr_LIST: '/grntr/get-grntr-list',
    grntr_ACT_LIST: '/grntr/get-act-grntr-list',
    grntr_clnt_SAVE: '/grntr/save-grntr-clnt',
    grntr_clnt_LIST: '/grntr/get-grntr-clnt-list', // + /stpGrntrSeq
    crncy_SAVE: '/grntr/save-crncy',
    crncy_LIST: '/grntr/get-crncy-list',
    crncy_ACT_LIST: '/grntr/get-act-crncy-list',
    crncy_rt_SAVE: '/grntr/save-crncy-rt',
    crncy_rt_LIST: '/grntr/get-crncy-rt-list',
    get_all_doc_categories: '/get-all-doc-ctgry',
    save_doc_category: '/save-doc-ctgry',
    save_fncl_typ: '/save-fnc-typ',
    get_all_fncl_typ: '/get-all-fnc-typ',
    get_fncl_typ_val: '/get-fnc-val/',
    save_fncl_typ_val: '/save-fnc-val',
    get_actv_fnc_typ: '/get-act-fnc-typ',
    get_actv_fnc_val: '/get-act-fnc-val',
    save_type: '/save-typs',
    get_type: '/get-typs',

    save_question: '/qstnr/save-question',
    save_questionnaire: '/qstnr/save-qstnr',
    save_answer: '/qstnr/save-answr',

    get_question_list: '/qstnr/get-question-list',
    get_act_question_list: '/qstnr/get-act-question-list',
    get_questionnaire_list: '/qstnr/get-qstnr-list',
    // ===== GEO (FIXED) =====
    get_country_list: '/geo/get-country-list',
    get_answer_list: '/qstnr/get-answr-list',
    get_state_list: '/geo/get-state-list', // + /{cntrySeq}
    get_state: '/geo/get-state', // + /{stateSeq}

    get_district_list: '/geo/get-dst-list', // + /{stateSeq}
    get_district: '/geo/get-dstrct', // + /{dstrctSeq}

    get_tehsil_list: '/geo/get-thsl-list', // + /{dstSeq}
    get_tehsil: '/geo/get-thsl', // + /{thslSeq}

    get_city_thsl_list: '/geo/get-city-thsl-list',
    get_city_thsl: '/geo/get-city-thsl', // + /{thslSeq}

    // ===== SAVE =====
    save_country: '/geo/save-country',
    save_state: '/geo/save-state',
    save_district: '/geo/save-dstrct',
    save_tehsil: '/geo/save-tehsil',
    save_city_thsl: '/geo/save-city-thsl',

    // ===== OLD =====
    save_city: '/geo/add-city',
    get_cities: '/geo/get-all-cities',

    // ===== EMPLOYEE REGISTRATION =====
    save_emp: '/save-emp',
    get_all_emps: '/get-all-emps',

    // ===== DEPARTMENT HEAD =====
    save_dept: '/save-dept',
    get_all_depts: '/get-all-depts',
    save_dept_emp: '/save-dept-emp',
    get_dept_emps: '/get-dept-emps', // + /{deptSeq}

    // ===== TEAM LEAD =====
    save_team_lead: '/save-team-lead',
    get_team_lead: '/get-team-lead', // + /{deptSeq}

    // ===== RELATIONAL OFFICER =====
    save_ro: '/save-ro',
    get_ros: '/get-ros', // + /{orgTlSeq}

    // ================= INCOME STATEMENT =================
    SAVE_INCM_STMNT_TYP: '/save-incm-stmnt-typ',
    SAVE_INCM_STMNT_VAL: '/save-incm-stmnt-val',
    GET_ALL_INCM_STMNT_TYP: '/get-all-incm-stmnt-typ',
    GET_INCM_STMNT_VAL: '/get-incm-stmnt-val/', // + stmntTypSeq
    GET_ACT_INCM_STMNT_TYP: '/get-act-incm-stmnt-typ',
    GET_ACT_INCM_STMNT_VAL: '/get-act-incm-stmnt-val',

    // ================= FINANCIAL EXTRACT =================
    SAVE_FNC_EXTR_TYP: '/save-fnc-extr-typ',
    SAVE_FNC_EXTR_VAL: '/save-fnc-extr-val',
    GET_ALL_FNC_EXTR_TYP: '/get-all-fnc-extr-typ',
    GET_FNC_EXTR_VAL: '/get-fnc-extr-val/', // + fncExtrTypSeq
    GET_ACT_FNC_EXTR_TYP: '/get-act-fnc-extr-typ',
    GET_ACT_FNC_EXTR_VAL: '/get-act-fnc-extr-val',
  },

  FASCILITIES: {
    GET_FACILITIES: '',
    GET_FACILITY: '/', // + fcltySeq
    SAVE_FACILITY: '',
    SEND_SELECTED: '/restructure',
  },

  DISBURSEMENT: {
    SAVE: '',
    GET_BY_FACILITY: '/facility/',
    PAYMENT_SCHEDULE: '/payment-schedule/',
    SCHEDULE_UPDATE: '/payment-schedules',
    CONSOLIDATED_PAYMENTS: '/facility/consolidated-payments/',
    ACCRUED_INCOME_CLIENT: '/accrued-markup/client/',
    CALCULATE_ACCRUED: '/calculate',
    DELETE: '/del-dsbmt/',
    SAVE_DSBMNT_ADJ: '/sv-dsbmnt-adj',
  },

  CLIENT: {
    GET_CLIENTS: '',
    SAVE_CLIENT: '',

    // ===== CNIC EXPIRY =====
    GET_CNIC_EXP_LIST: '/get-cnic-exp-list',
    UPDATE_CNIC_EXP: '/update-cnic-exp',
    GET_INPROCS_CNIC_LIST: '/get-inprocs-cnic-list',
    APRV_CNIC_EXP: '/aprv-cnic-exp/', // + cnicNum
  },

  ADMIN: {
    GET_GOLD_RATE: '/get-gold-rate/',
    SAVE_GOLD_RATE: '/save-gold_rate',

    // ================= ROLE =================
    SAVE_ROLE: '/save-role',
    SAVE_APP_ACCESS: '/save-app-access',
    GET_ROLES: '/get-roles',

    GET_AUTH_LIST: '/get-auth-list/', // + rolID
    GET_AUTH_LIST_FOR_ROLE: '/get-auth-list-for-rol/', // + rolSeq

    GET_ALL_SUB_MODES: '/get-all-sub-modes',
    GET_ALL_ROLES: '/get-all-roles',
    GET_ALL_MODES: '/get-all-modes',
  },

  RECOVERY: {
    GET_PENDING: '/pymt/get-pending-pymnt/',
    POST_RECOVERY: '/pymt/post-recovery/',
    MARK_ACCRUED_PAID: '/mark-accrued-paid/',
    MARK_ACCRUED_PAID_consolidated_payment: '/consolidated-payment',
    MARK_ACCRUED_PAID_partial_payment: '/partial-payment',
    MARK_SCHEDULE_PAID: '/mark-schedule-paid/',
    MARK_SCHEDULE_PAID_FOR_PHASE: '/mark-schedule-paid-for-phase/',
    PROCESS_PAYMENT: '/process-payment/',
    PAYMENT_DETAILS: '/payment-details/',
    GET_CLNT_OTSTNDNG: '/get-clnt-otstndng/', // + clntSeq/fcltyTypKey
    ACCRUD_MARKUP: '/accrued-markup/facility/',
    ACCRUD_MARKUP_BY_DSBMNT: '/get-by-dsbmnt/',
    ACCRUED_INCOME: '/consolidated-view/',
    PAY_ACCRUD_MARKUP_BY_DSBMNT: '/pay-by-dsbmnt/',
    GET_PENALTY_BY_FACILITY: '/get-all-pnlty-by-fclity/',
    COMPLETE_SCHEDULE: '/complete-schedules/',
    COMPLETE_SCHEDULE_FACILITY: '/complete-schedules-by-fclity/',
  },

  REPORTS: {
    TASDEEQ: '/reports/print-tasdeeq-report/',
    DISBURSEMENT_REPORT: '/get-disbursement-report/',
    REPAYMENT_REPORT: '/get-repayment-report/',
    EXPOSURE_REPORT: '/get-exposure-report/',
    APPROVED_FACILITIES_REPORT: '/get-apprvd-facilities-rprt/',
    PROJECTION_REPORT: '/get-prjctns-rprt/',
    ENHANCED_APPROVED_FACILITIES_REPORT: '/get-enhncd-apprvd-facilities-rprt/',
    // Lives under the reports service's own /qpr-reports root, not /reports.
    CONSOLIDATED_QPR_REPORT: '/get-qpr-rprt',
    PB_CONSOLIDATED_QPR_REPORT: '/get-consolidated-qpr-rprt',
    QPR_REPORT: '/qpr/report',
    QPR_SUBMIT: '/qpr/submit',
    QPR_DOCUMENTS: '/qpr/documents',
    MPR_REPORT: '/mpr/report',
    MPR_SUBMIT: '/mpr/submit',
    MPR_DOCUMENTS: '/mpr/documents',
    CONSOLIDATED_MPR_REPORT: '/mpr/get-mpr-rprt',
  },
  JOURNAL: {
    GET_VOUCHERS: '/get-jrnl-vchr-lst',
    GET_VOUCHER_DETAILS: '/get-jrnl-vchr-dtl-lst/',
  },

  LEADS: {
    // ================= CREATE / SAVE =================
    SAVE_LEAD: '/save-lead',
    SAVE_TERM_SHEET: '/save-term-sheet',

    // ⚠️ your backend uses upload-lead-docs (not save)
    UPLOAD_LEAD_DOCS: '/upload-lead-docs',
    SEND_BACK_TO_RO: '/sndbck-lead',
    // ================= UPDATE =================
    UPDATE_STATUS: '/upd-lead-sts', // + leadSeq
    APPROVE_LEAD: '/apprv-lead', // + leadSeq
    SUBMIT_LEAD: '/submit-lead/', // + leadSeq

    // ================= GET =================
    GET_LEAD: '/get-lead/', // + leadSeq
    GET_LEAD_LIST: '/get-lead-list',

    GET_LEAD_TERM: '/get-lead-trm/', // + trmSeq
    GET_LEAD_TERM_LIST: '/get-lead-trm-list/', // + leadSeq

    GET_LEAD_DOCS: '/get-lead-docs-list/', // + leadSeq
    GET_LEAD_DOC_HISTORY: '/get-lead-doc-hstry/', // + leadSeq

    GET_CLIENT_APPROVAL_LIST: '/get-clnt-aprvl-lead-list',

    GET_ALL_STP_LEADS_DOCS: '/get-all-stp-lead-docs',
    GET_ALL_LEADS_COUNT: '/get-all-leads-count',
    GET_CLIENT_APPROVEL_LIST: '/get-clnt-aprvl-lead-list',
    REJECT_LEAD: '/rjct-lead', //+ leadSeq
    REJECT_LEAD_INTRNL: '/rjct-lead-intrnl',
    GET_ONBORAD_APRVD_LIST: '/get-aprvd-lead-list',
  },
  ONBOARDING: {
    SAVE_CORPT_INFO: '/add-corporate-information',
    GET_CORPT_INFO_BY_ENTITY: '/get-corporate-information',
    SAVE_ONBORDING: '/save-onbrdng-rvw',
    SUBMIT_ONBOARDING: '/submit-onbrdng',
    GET_ONBOARDING_REVIEW: '/onbrdng-rvw',
    GET_RO_RVW: '/ro-rvw',
    SAVE_RVW: '/save-rvw',
    GET_CORPT_INFO: '/corporate-information',
    GET_RISK_FACTA: '/risk-facta-information',
    SAVE_RISK_FACTA: '/save-risk-facta',
    SAVE_CORPORATE_PERSON: '/save-corporate-person',
    GET_CORPORATE_PERSONS: '/corporate-persons', // query params
    GET_CORPORATE_PERSON: '/corporate-person', // + /{prsnSeq}
    GET_ALL_CORPORATE_PERSONS: '/all-corporate-persons', // + /{crptOnbrdngSeq}
    SAVE_CMT_MMBRS: '/save-cmt-mmbrs',
    GET_ALL_CMT: '/all-cmt', // + /{crptOnbrdngSeq}
    RJCT_ONBRNG_CLNT: '/rjct-onbrdng', //leadSeq
    SEND_BACK_ONBRNG_CLNT: '/sndbck',
  },

  NOTIFICATION: {
    GET_ALL_NOTIFICATIONS: '/get-all-ntfctn',

    GET_UNREAD_NOTIFICATIONS: '/unread',

    MARK_NOTIFICATION_READ: '/read',
  },

  TASKS: {
    GET_MY_TASKS: '/get-my-tsks',
    PROCESS_TASK: '/process-task',
  },
  CRADIT: {
    SAVE_CRDT_PRPSL_LIST: '/save-crdt-prpsl-list',
    GET_CRDT_PRPSL_LIST: '/get-crdt-prpsl',
    SAVE_CRDT_PRPSL_RISK: '/save-crdt-prpsl-rsk',
    GET_CRDT_PRPSL_RISK_LIST: '/get-rsk-lst',
    SAVE_CRDT_PRPSL_TBL: '/save-crdt-prpsl-tbl',
    GET_CRDT_PRPSL_TBL: '/get-crdt-prpsl-tble',
    SAVE_SECTIONS_CRDIT_PERPOSAL: '/save-sctions',
    SAVE_FINACL_DATA: '/save-fncl-dta',
    GET_FINACL_DATA: '/get-fncl-dta',
    GET_ALL_SECTION: '/get-all-sctions',
    GET_CRDT_BLCK: '/get-crdt-blcks',
    GET_OB_APRVD_LIST: '/get-crd-list',
    SAVE_CRDT_PRPSL: '/save-crdt-prpsl',
    SAVE_TERM_PARAMETERS: '/save-trm-params',
    GET_CRDT_TRMS_PRMS: '/get-crdt-trm-params/',
    MAX_PRVS_EXPOR: '/prev-max-exposure/',
    GET_FINANCIAL_ANALYSIS: '/get-fnc-anlsys',
    GET_FINANCIAL_HIGHLIGHTS: '/get-financial-highlights/',
    SUBMT_CRDT_PRPOSL: '/submit-crdt-prpsl',
    CALCULATE_REPAYMENT_PLAN: '/clclate-rpymnt-plan',
    MAX_EXPOURE: '/prev-max-exposure/',
    SAVE_REPAYMENT_PLAN: '/clclt-dsbrsmnt-repayment-plan',
    GET_EXISTING_REPYMNT: '/existing-repyment/',
    GET_EXISTING_DSBMNT: '/existing-dsbmnt/',
    GET_CRDT_FO_LTR: '/get-crdt-fo-ltr',
    GET_APRVD_FO_LTR: '/fo-ltr/aprvd-lst',
    PENDING_DRAFT_FO_LTR_DOCS: '/fo-ltr/pending-draft-docs',
    PENDING_DRAFT_FO_LTR_CLNT_LST: '/fo-ltr/pending-draft-clnt-lst',
    RO_ACCEPTANCE_PENDING_CLNT_LST: '/fo-ltr/ro-acptnc-pndng-clnt-lst',
    RO_ACCEPTANCE_PENDING_DOCS: '/fo-ltr/ro-acptnc-pndng-docs', // ?crdtFoLtrSeq=
    RO_APPROVE_DRAFT_FO_LTR_DOCS: '/fo-ltr/ro-approve-draft-docs',
    ADD_FO_LTR_RECOMMENDATION: '/fo-ltr/add-recommendation',
    FO_LTR_RCMND_REQUIRED_LST: '/fo-ltr/rcmnd-required-lst',
    FO_LTR_MRC_BRC_REQUIRED_CLNT_LST: '/fo-ltr/mrc-brc-required-clnt-lst',
    FO_LTR_MRC_BRC_REQUIRED_DOCS: '/fo-ltr/mrc-brc-required-docs',
    FO_LTR_XTNSN_REQUEST: '/fo-ltr/xtnsn-request',
    FO_LTR_XTNSN_PENDING_CLNT_LST: '/fo-ltr/xtnsn-pending-clnt-lst',
    FO_LTR_XTNSN_PENDING_LST: '/fo-ltr/xtnsn-pending-lst',
    FO_LTR_XTNSN_GRANT: '/fo-ltr/xtnsn-grant',
    FO_LTR_XTNSN_REJECT: '/fo-ltr/xtnsn-reject',
    GET_FO_LTR_REVIEW: '/fo-ltr/fo-ltr-rvw/', // + entySeq/entyTyp
    GET_FO_LTR_TRM_PARAMS: '/fo-ltr/trm-params/', // + crdtFoLtrSeq
    PRINT_FO_LTR: '/fo-ltr/print-fo-ltr/', // + crdtFoLtrSeq
    GET_TRM_PARAMS_FOL: '/fo-ltr/trm-params-fol/', // + crdtFoLtrSeq
    // FOL new flow — Stage 2 (issue-flag documents)
    SAC_PENDING_FO_LTR_CLNT_LST: '/fo-ltr/sac-pndng-clnt-lst',
    PENDING_LEGAL_OPINION_LST: '/fo-ltr/pndng-lgl-opnn-lst',
    SAC_PENDING_FO_LTR_DOCS: '/fo-ltr/sac-pndng-lst', // ?crdtFoLtrSeq=
    SAC_APPROVE_FO_LTR_DOC: '/fo-ltr/sac-aprv',
    SAC_REJECT_FO_LTR_DOC: '/fo-ltr/sac-rjct',
    RO_PENDING_FO_LTR_CLNT_LST: '/fo-ltr/ro-pndng-clnt-lst',
    RO_PENDING_FO_LTR_DOCS: '/fo-ltr/ro-pndng-lst', // ?crdtFoLtrSeq=
    RO_APPROVE_FO_LTR_DOC: '/fo-ltr/ro-doc-aprv',
    RO_RECOMMEND_FO_LTR_DOC: '/fo-ltr/ro-doc-rcmnd',
    AM_DOC_PENDING_FO_LTR_DOCS: '/fo-ltr/am-doc-pndng-lst', // ?crdtFoLtrSeq=
    UPDATE_FO_LTR_HRD_CPY_DT: '/fo-ltr/update-hrd-cpy-dt',
    VCM_APPROVE_FO_LTR_RECOMMENDATION: '/fo-ltr/vcm-approve-recommendation',
    VCM_REJECT_FO_LTR_RECOMMENDATION: '/fo-ltr/vcm-reject-recommendation',
    SAVE_FO_LTR_DOC: '/fo-ltr/save-doc',
    GET_FO_LTR_DOC: '/fo-ltr/get-fo-ltr-doc',
    GET_FO_LTR_DOC_HISTORY: '/fo-ltr/get-fo-ltr-doc-hstry/', // + crdtFoLtrSeq/docSeq
    GET_FO_LTR_ISSU_DOC: '/fo-ltr/get-fo-ltr-issu-doc',
    GET_FO_LTR_PARAMS: '/get-fo-ltr-params/', // + crdtPrpslSeq
    GET_PRPSD_DSBMNT_LIST: '/get-prpsd-dsbmnt-list',
    GET_PENDING_PRPSD_DSBMNT_LIST: '/get-pending-prpsd-dsbmnt-list',
    GET_COVENANT_RESPONSES: '/get-covenant-responses/', // + crdtPrpslSeq
    GET_COVENANT_RESPONSES_BY_CLIENT: '/get-cnvnt-rsp-by-clnt/', // + clntSeq
    GET_PREVIOUS_COVENANT_RESPONSES: '/get-prev-cnvnt-rsp/', // + crdtPrpslSeq
    SAVE_COVENANT_RESPONSES: '/save-covenant-responses',
    GET_COVENANT_QUESTIONS: '/get-covenant-questions/', // + crdtPrpslSeq
    SAVE_COVENANT_QUESTIONS: '/save-covenant-questions',
    GET_CRDT_GRNTRS: '/get-crdt-grntrs/', // + crdtPrpslSeq
  },
  // Served by crdt-prpsl-servc, but rooted at /mntrng rather than /crdt-prpsl.
  MONITORING: {
    SAVE_MNTRNG: '/save-mntrng',
    GET_PENDING_MNTRNG: '/get-pending-mntrng/', // + clntSeq
    GET_PREV_MNTRNG: '/get-prev-mntrng/', // + clntSeq
    GET_NEW_FINDINGS: '/get-new-findings/', // + clntSeq/year
    GET_CLIENTS: '/clients',
    GET_ALL_MNTRNG: '/get-all-mntrng/', // + clntSeq
  },

  DISBURSEMENT_NOTE: {
    GET_PRPSD_DSBMNT: '/get-prpsd-dsbmnt/', // + prpsdDsbmntSeq

    // Path spelling ("dsmbmnt") is the backend's own — kept verbatim so the
    // call resolves; correct it here if the service is ever renamed.
    SUBMIT_DSBMNT_NOTE: '/submit-dsmbmnt-note/', // + prpsdDsbmntSeq
    SAVE_CAD_RSP: '/save-cad-rsp',
    GET_CAD_RSP: '/get-cad-rsp/', // + prpsdDsbmntSeq
    GET_GRNTR_LMT_UTLZD: '/get-grntr-lmt-utlzd/', // + prpsdDsbmntSeq
    SAVE_PRPSD_DSBMNT_GRNTR: '/save-prpsd-dsbmnt-grntr',
    GET_PRPSD_DSBMNT_GRNTR: '/get-prpsd-dsbmnt-grntr/', // + prpsdDsbmntSeq
    GET_CLNT_GRNTRS: '/get-clnt-grntrs/', // + prpsdDsbmntSeq
  },
  REPAYMENT: {
    SAVE_PRPSD_DSBMNT: '/prpsd-dsbmnt',
    GET_PRPSD_DSBMNT: '/get-prpsd-dsbmnt/',
    SAVE_PRPSD_RPYMNT: '/prpsd-rpymnt',
    GET_PRPSD_RPYMNT: '/get-prpsd-rpymnt/',
    SAVE_REPAYMENT_DISBURSMENT:"/save-rpymnt-dsbmnt",
    GET_PRPSD_DSBMNT_RPYMNT: '/get-prpsd-dsbmnt-rpymnt/', // + crdtPrpslSeq
  },
};
